import { Currency } from '@seapoint/server/enums';
import { cn } from '../../utils/cn';
import { getAmountWithCurrency } from '../../utils/get-amount-with-currency';

type AmountDisplayProps = {
  /**
   * The amount to display, normalized to show positive values for incoming money
   * and negative values for outgoing money
   */
  normalizedAmount: number;
  currency?: Currency;
  /**
   * When true, renders the amount in a smaller font size and gray color,
   * typically used to display secondary amounts
   */
  isSecondary?: boolean;
  /**
   * Controls sign display behavior:
   * - true: Account balance mode - shows no sign for positive, - for negative
   * - false (default): Transaction mode - shows + for positive, no sign for negative
   */
  isAccountBalance?: boolean;
  className?: string;
};

export const AmountDisplay = ({
  normalizedAmount,
  currency,
  isSecondary = false,
  isAccountBalance = false,
  className,
}: AmountDisplayProps) => {
  const amountWithCurrency = getAmountWithCurrency({ amount: normalizedAmount, currency, isAccountBalance });

  if (isSecondary) {
    return <p className={cn('text-xs tabular-nums text-seapoint-gray-text', className)}>{amountWithCurrency}</p>;
  }

  return (
    <p
      className={cn(
        // tabular-nums is needed for the amounts displayed
        // https://v3.tailwindcss.com/docs/font-variant-numeric#tabular-figures
        'text-nowrap text-sm tabular-nums',
        {
          'text-seapoint-green': normalizedAmount > 0,
          'text-black': normalizedAmount <= 0,
        },
        className,
      )}
    >
      {amountWithCurrency}
    </p>
  );
};
